import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_SERVER

const logConsoleError = async (params) => {
    const {
        error
    } = params
    return await axios.post('/controllers/logError.php', {
        error
    })
}

export {
    logConsoleError
}
